import "./component-base.scss";
import { LitElement } from "lit";

class ComponentBase extends LitElement {
  static get tagName() {
    return "component-base";
  }

  createRenderRoot() {
    return this;
  }

  static Register() {
    customElements.define(this.tagName, this);
  }
}

export default ComponentBase;
